import React, { useState, useEffect } from "react";
import cx from "classnames";
import { makeRequest, fetcher } from "../../utils/request";
import constants from "../../config/constants";
import LogsService from "../../utils/logs";
import useSWR from "swr";
import Select from 'react-select'
import { sanitizeFormInput } from "../../utils/helper";
import { pushDatatoAdobeLayer } from "../../analytics/pmiAdobeLog";
import { getAdobeAnalyticsEventObject, getAdobeAnalyticsCustomLinkObj } from '../../analytics/analyticsObject';
import {

    getUrlWithoutPathname,

} from "../../utils/utility";
const NotFoundForm = ({ canProceed, userId }) => {
    const [topicValue, setTopicValue] = useState("");
    const [contentTypeValue, setContentTypeValue] = useState([]);
    const [problemValue, setproblemValue] = useState("");
    const [messageSent, setMessageSent] = useState(false);
    const [userInteracted, setuserInteracted] = useState(false);
    const topicFilled = () => (topicValue !== "");
    const contentTypeFilled = () => (contentTypeValue?.length);
    const problemValueFilled = () => (problemValue !== "");
    const formFilled = () => (topicFilled() && contentTypeFilled() && problemValueFilled());

    const swrOptions = {
        revalidateOnFocus: false,
    };

    const groupKey = constants.commentGroupKeys.notFound;
    const groupTitle = constants.commentGroupTitles.notFound;
    const { data: contentTypeOptions } = useSWR(
        `/api/commentoptions/query?groupKey=${groupKey}`,
        fetcher,
        swrOptions
    );
    const formStart = (e) => {
        setuserInteracted(true);
        if (userInteracted == false) {
            let contEventObj = getAdobeAnalyticsEventObject(
                "form-interaction",
                "form-interaction",
            );
            // let customEventObj = getAdobeAnalyticsEventObject("linkClick", "linkClick");
            let customLObj = getAdobeAnalyticsCustomLinkObj(
                'form-interaction',
                "feedback-form",
            );
            let feedbackTrack = {
                event: "form-interaction",
                eventInfo: "form-interaction",
                form: {
                    action: "form-start",
                    formName: "feedback-form",
                    formError: "Not available",
                }
            }

            pushDatatoAdobeLayer({
                // customLinkData: { ...customEventObj, ...customLObj },
                onContClickData: { ...contEventObj, ...feedbackTrack },
                pageData: false,
                adobePushTracking: false,
            });
        }
    }
    const feedbacksubmit = () => {
        let contEventObj = getAdobeAnalyticsEventObject(
            "form-interaction",
            "form-interaction",
        );
        // let customEventObj = getAdobeAnalyticsEventObject("linkClick", "linkClick");
        let customLObj = getAdobeAnalyticsCustomLinkObj(
            'form-interaction',
            "feedback-form",

        );
        let feedbackTrack = {
            event: "form-interaction",
            eventInfo: "form-interaction",
            form: {
                action: "form-completed",
                formName: "feedback-form",
                formError: "Not available",
            }
        }

        pushDatatoAdobeLayer({
            // customLinkData: { ...customEventObj, ...customLObj },
            onContClickData: { ...contEventObj, ...feedbackTrack },
            pageData: false,
            adobePushTracking: false,
        });
    }

    const submitForm = async () => {
        feedbacksubmit()
        if (!canProceed()) {
            return;
        }

        const contentTypes = contentTypeValue?.map(contentType => {
            return {
                id: contentType.data.id,
                name: contentType.data.name
            }
        })

        const payload = {
            userId: userId,
            message: sanitizeFormInput(topicValue),
            contentType: contentTypes,
            problem: sanitizeFormInput(problemValue),
        };

        const data = {
            contentKey: constants.contentKeys.notFoundForm,
            content: JSON.stringify(payload),
            commentType: constants.commentTypes.feedback,
            commentSubtype: {
                groupKey: groupKey,
                groupTitle: groupTitle
            }
        };

        await makeRequest("POST", `/api/comment`, data);
        await LogsService.logFeedbackSent(payload);
        setTopicValue("");
        setContentTypeValue([]);
        setproblemValue("");
        setMessageSent(true);

    };

    const getContentTypes = () => {
        const selectOptions = typeof contentTypeOptions === "object" ? contentTypeOptions?.map((option, index) => {
            return {
                label: option.name,
                data: option,
                value: JSON.stringify(option)
            }
        }) : null;
        return selectOptions;
    }

    return (
        <div className="py-8 text-gray-700" adoberegion='form-interaction'>

            <div className="bg-white flex flex-col container mx-auto px-4 pt-8 pb-4 border border-gray-500 rounded-sm">

                <div className="w-full lg:flex-1 mb-8">
                    <div className="mb-10 w-full lg:px-8">
                        <h1 className="font-light text-4xl text-center title-font">
                            Don't see the results you're
                            <br />
                            looking for?
                        </h1>
                    </div>
                </div>

                {messageSent ? (
                    <div className="flex justify-center items-center mb-8 lg:px-8">
                        <span className="text-center text-green-600 font-bold title-font">
                            Thank you for your feedback!
                        </span>
                    </div>
                ) : (

                    <>

                        <div className="inline-block relative w-full mb-8">
                            <label className="block tracking-wide text-gray-700 text-md font-bold mb-4" htmlFor="topic">
                                What topic are you looking for?
                            </label>
                            <textarea
                                id="topic"
                                type="text"
                                placeholder="Enter the topic you are looking for?"
                                value={topicValue}
                                maxLength="500"
                                onChange={e => (setTopicValue(e.target.value))}
                                className={cx(
                                    "border border-gray w-full py-4 px-4",
                                    {
                                        "text-gray-500": !topicFilled(),
                                        "text-gray-700": topicFilled()
                                    }
                                )}
                                onClick={formStart}
                            />
                            <p className="text-xs mt-2 mb-8">500 character limit</p>
                        </div>

                        <div className="inline-block relative w-full mb-8">
                            <label className="block tracking-wide text-gray-700 text-md font-bold mb-4" htmlFor="topic">
                                What content format would help you learn more about this topic?
                            </label>
                            <div className="inline-block relative w-full">
                                <Select
                                    options={getContentTypes()}
                                    isMulti={true}
                                    onChange={(e) => {
                                        setContentTypeValue(e);
                                        formStart(e)
                                    }}
                                />
                            </div>
                        </div>

                        <div className="inline-block relative w-full mb-8">
                            <label className="block tracking-wide text-gray-700 text-md font-bold mb-4" htmlFor="problem">
                                What problem are you trying to solve?
                            </label>
                            <textarea
                                id="problem"
                                type="text"
                                placeholder="Enter the problem you are trying to solve."
                                value={problemValue}
                                maxLength="500"
                                onChange={e => { setproblemValue(e.target.value) }}
                                onClick={formStart}
                                className={cx(
                                    "border border-gray w-full py-4 px-4",
                                    {
                                        "text-gray-500": !problemValueFilled(),
                                        "text-gray-700": problemValueFilled()
                                    }
                                )}
                            />
                            <p className="text-xs mt-2 mb-8">500 character limit</p>
                        </div>

                        <div className="inline-block relative w-60 mx-auto mb-8">
                            <button
                                className={cx(
                                    "rounded text-white font-normal py-4 px-6 btn-font",
                                    {
                                        "bg-gray-600": !formFilled(),
                                        "border border-l-0 border-blue bg-blue-700": formFilled()
                                    }
                                )}
                                disabled={!formFilled()}
                                onClick={() => submitForm()}
                            >
                                SUBMIT
                            </button>
                        </div>

                    </>

                )}


            </div>

        </div>
    );
};

export default NotFoundForm;
